import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

const Wrapper = styled.li`
  display: flex;
  flex-direction: row;
  margin-top: 14px;
  margin-bottom: 14px;

  &:first-child {
    margin-top: 0;
  }
`

const Bullet = styled.div`
  ${({
    theme: {
      colors: {
        brandColors: { brand_55 },
      },
    },
  }) => css`
    margin-left: 5px;
    margin-top: 5px;
    margin-right: 10px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background-color: ${brand_55};
  `}
`

const Text = styled.div`
  ${({
    theme: {
      fonts: { goodOT },
      colors: {
        grey: { grey_100 },
      },
    },
  }) => css`
    flex: 1;
    font-family: ${goodOT};
    font-size: 18px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.5px;
    line-height: normal;
    text-align: left;
    color: ${grey_100};
  `}
`

const BulletpointsItem: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => (
  <Wrapper>
    <Bullet />
    <Text>{children}</Text>
  </Wrapper>
)

export default BulletpointsItem
